import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BaseParamsService } from '../../../../core/base-params.service';
import { find } from 'browser-langs';
import { CommonModule } from '@angular/common';
import { LanguageSettingsService } from '@app/core/settings/language/language-settings.service';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagePickerComponent implements OnInit, OnDestroy {
  public findLang = find;

  @Input()
  public set languages(val: string[] | null | undefined) {
    this._languages = val || [];
  }

  public get languages(): string[] {
    return this._languages;
  }

  private _languages: string[];
  protected formControl;
  private formSub: Subscription;

  constructor(private languageSettings: LanguageSettingsService,
              private baseParamsService: BaseParamsService) {
  }

  public ngOnInit(): void {
    this.formControl = new FormControl(this.getDefaultLanguage() || 'default');
    this.formSub = this.formControl.valueChanges.subscribe((lang) => this.formControlChange(lang));
  }

  public ngOnDestroy(): void {
    this.formSub.unsubscribe();
  }

  private formControlChange(language): void {
    this.languageSettings.saveChosenLanguage(language);
    this.languageSettings.setLanguage(language);
  }

  private getDefaultLanguage(): string | void {
    if (this.baseParamsService.language && this.languages.includes(this.baseParamsService.language)) {
      return this.baseParamsService.language;
    }
  }
}
